module.exports = __webpack_public_path__ + "img/nfcc.ce2934d4.png";